import { SESSION_CHANNEL_NAME } from '@/constants/auth';

export type SessionMessage = 'signed-out' | 'role-switched';

// One instance per tab: a BroadcastChannel never delivers to the object that
// posted, so posting and listening through the same one keeps a tab from
// reacting to its own announcement.
let channel: BroadcastChannel | null | undefined;

const getChannel = (): BroadcastChannel | null => {
  if (channel === undefined) {
    channel =
      typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(SESSION_CHANNEL_NAME);
  }

  return channel;
};

export const announceSession = (message: SessionMessage): void => {
  getChannel()?.postMessage(message);
};

/** Returns the unsubscribe function. */
export const listenForSession = (onMessage: (message: SessionMessage) => void): (() => void) => {
  const target = getChannel();
  if (!target) return () => undefined;

  const handler = (event: MessageEvent<unknown>) => {
    if (event.data === 'signed-out' || event.data === 'role-switched') onMessage(event.data);
  };

  target.addEventListener('message', handler);
  return () => target.removeEventListener('message', handler);
};
